import React from "react";
import AnchorButton from "../../components/AnchorButton/AnchorButton";
import GetText from "../../i18n/GetText";
import { useLanguage } from "../../i18n/LanguageContext";
import { SanityImage, SanityInternalLink } from "../../model/common";
import { useIsRtl } from "../../utils/LayoutContext";
import { imageUrlBuilder } from "../../utils/images";
import { Col, Row, Wrapper } from "../Grid";
import { internalLinkUrl } from "../InternalLink/InternalLink";
import Text from "../Text/Text";
import styles from "./HomePageMicrobitBlock.module.scss";

interface HomePageMicrobitBlockProps {
  desktopImage: SanityImage;
  mobileImage: SanityImage;
  callToAction: SanityInternalLink;
  callToActionText: string;
}

const HomePageMicrobitBlock = ({
  callToAction,
  callToActionText,
  desktopImage,
  mobileImage
}: HomePageMicrobitBlockProps) => {
  const isRtl = useIsRtl();
  const language = useLanguage();
  const imageHeight = 510;
  return (
    <>
      <div className={styles.root} dir="ltr">
        <Wrapper className={styles.wrapperPadding}>
          <Row className={styles.topRow}>
            <Col md={5} sm={12} className={styles.leftContainer}>
              <div className={styles.content} dir={isRtl ? "rtl" : "ltr"}>
                <Text variant="h1">Micro:bit Educational Foundation</Text>
                <p className={styles.strapline}>
                  <GetText
                    id="strapline"
                    fallback="Inspire every child to create their best digital future"
                  />
                </p>
                <Row className={styles.buttonContainer}>
                  <AnchorButton
                    primary={true}
                    to={internalLinkUrl(
                      callToAction.reference,
                      callToAction.query,
                      callToAction.fragment,
                      language
                    )}
                  >
                    {callToActionText}
                  </AnchorButton>
                </Row>
              </div>
            </Col>
            <Col className={styles.desktopImageCol} md={7}>
              <img
                height={imageHeight}
                src={
                  imageUrlBuilder
                    .image(desktopImage)
                    .height(imageHeight * 2)
                    .url()!
                }
                alt={desktopImage.alt}
              />
            </Col>
          </Row>
          <Row className={styles.mobileImageRow}>
            <Col className={styles.noPadding}>
              <img
                src={
                  imageUrlBuilder
                    .image(mobileImage)
                    .width(991)
                    .url()!
                }
                alt={mobileImage.alt}
              />
            </Col>
          </Row>
        </Wrapper>
      </div>
    </>
  );
};

export default HomePageMicrobitBlock;
